import { quietLoad } from "@/utils/overlayControl.js";

/**
 * Runs an async task while toggling a component-local loading flag.
 * Suppresses mixin setOverlay calls so only the target control shows a loader.
 */
export async function withFieldLoading(vm, flag, task) {
  if (!vm || !flag) {
    return typeof task === "function" ? task() : task;
  }

  vm[flag] = true;
  try {
    return await quietLoad(vm, () =>
      typeof task === "function" ? task() : task,
    );
  } finally {
    vm[flag] = false;
  }
}
